import React, { useEffect } from "react";
import { Button, Icon, TutorialContainer } from "../../../_components";
import { useModal } from "../../../_contexts";

export function SetupCompletePage({ navMethods }) {
  const { closeModal, openModal } = useModal();

  const handleDocumentationClick = () => {
    openModal("help", { firstTime: true });
  };

  const handleCloseClick = () => {
    closeModal();
  };

  useEffect(() => {
    navMethods.setShowNavigation(false);
  }, []);

  return (
    <div className="chronos-setup-complete-page">
      {/* GIF */}
      <TutorialContainer
        type="video"
        url="https://wa-cdn.nyc3.cdn.digitaloceanspaces.com/chronos/65888baf-306e-492b-be0d-effa4acdf680.webm"
      />
      <div className="content-page-wrapper">
        <h2 className="chronos-wizard-page-title">Setup Complete!</h2>
        <p className="chronos-wizard-text">
          Congratulations! Your Chronicle is ready!
        </p>
        <p className="chronos-wizard-text">
          Now, go fill it with hundreds of Historical Events and Map Markers!
          Now go become a master of time and space!
        </p>

        <label className="chronos-form-title">Hints &amp; Tips:</label>
        <ul className="chronos-list">
          <li className="chronos-wizard-hint-item">
            Right click on the map to create a Marker
          </li>
          <li className="chronos-wizard-hint-item">
            Right click on the timeline to create an Event
          </li>
          <li className="chronos-wizard-hint-item">
            For HELP, click the &nbsp;
            <Icon icon="fas fa-book fa-fw" style={{ color: "#666" }} />
            &nbsp;on the right edge of the screen
          </li>
        </ul>

        <div className="chronos-wizard-cta">
          <Button onClick={handleDocumentationClick} color="info">
            <Icon icon="fas fa-book fa-fw" />
            &nbsp;Read the Manual
          </Button>
          <Button onClick={handleCloseClick} color="success">
            <Icon icon="fas fa-check fa-fw" />
            &nbsp;Get Started
          </Button>
        </div>
      </div>
    </div>
  );
}
